import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=59c9d947&scoped=true"
import script from "./sms.vue?vue&type=script&lang=ts"
export * from "./sms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9d947",
  null
  
)

export default component.exports